import { TypeAheadInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { list } from '../../../../../common/classes/request-builder';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';

export class CamposListsDefinition {
  public fincas: TypeAheadInterface<FincasModel> = list();
      public parcelas: TypeAheadInterface<ParcelasModel> = list();
      public cultivos: TypeAheadInterface<VisitasVariedadMesModel> = list();
      public variedades: TypeAheadInterface<VisitasVariedadMesModel> = list();
  
      public patron: TypeAheadInterface<string> = list(
          ['...', null]
      );
  
      public patronAlmendro: TypeAheadInterface<string> = list(
          ['...', null],
          'Franco de semilla'
      );
      public patronManzano: TypeAheadInterface<string> = list(
          ['...', null],
          // Fuji
          'Kiku',
          'Fubrax',
          'Zhen Aztec',
          'San',
          'September Wonder',
          // Gala
          'Brookfield',
          'Scniga',
          'Vinus',
          'Schnicored',
          // Golden'
          'Delicious',
          'Smoothee',
          'Reinders',
          'Parsi',
          // Granny Smith
          'Challenger',
          // Red Delicious
          'Starking',
          'Golden Rose',
          'Jeromine',
          'Scarlet Spur',
          // Reineta
          'Blanca',
          'Parda',
          // Otros patrones
          'M12',
          'M7',
          'M9',
          'MM106'
      );
      public patronMelocotonero: TypeAheadInterface<string> = list(
          ['...', null],
          'GF-677', 'GxN Garnem', 'Monclart'
      );
      public patronCerezo: TypeAheadInterface<string> = list(
          ['...', null],
          'Adara', 'Avium', 'Cab6', 'Col', 'Marina-Adara', 'Maxma', 'Santa Lucía', 'Santa Lucía 64'
      );
      public patronCiruelo: TypeAheadInterface<string> = list(
          ['...', null],
          'Mariana', 'Melocotonero', 'Mirobolán C'
      );
      public patronCitricos: TypeAheadInterface<string> = list(
          ['...', null],
          'Carrizo', 'Cleopatra', 'Forner Alcaide', 'Macrophylla', 'Naranjo Borde', 'Volkameriana',
      );
      public patronPera: TypeAheadInterface<string> = list(
          ['...', null],
          'BA-29', 'EM-C', 'Franco', 'Membrillero'
      );
      public patronVina: TypeAheadInterface<string> = list( // Portainjerto
          ['...', null],
          'R110', '1103/P', 'RU/140', 'SO4', 'M1', 'M2', 'M3', 'M4'
      );
}